import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoaderService } from '../shared/services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loader: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.method === 'GET') {
      this.loader.show('', false);
    }

    if (['POST', 'PUT', 'DELETE'].includes(req.method)) {
      this.loader.show('LAYOUT.PROCESSING_REQUEST', true);
    }

    return next.handle(req).pipe(
      finalize(() => this.loader.hide())
    );
  }
}
